export default function generateRandomKey() {
  return (Math.random() * 100000).toString();
}
